function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import { useCallback, useEffect, useRef, useState } from 'react';
import * as React from 'react';
import ReactResizeDetector from 'react-resize-detector';

import { useOverrides } from "../hooks/useOverrides";

import { ErrorScreen } from "./ErrorScreen";

import {
Content as ContentComponent,
Container as ContainerComponent,
ShimmerEffect } from "./ShimmingCard.styles";


const defaultComponents = {
  Content: ContentComponent,
  Container: ContainerComponent,
  ErrorScreen };

















const ShimmingCard = ({
  className = '',
  loading = false,
  children,
  defaultHoverBehavior = false,
  elevated = false,
  hasError = false,
  errorTitle,
  errorMessage,
  contactButtonText,
  onContactButtonClick,
  staticHeight = 150,
  overrides = {} }) =>
{
  const [height, setHeight] = useState(null);
  const [opacity, setOpacity] = useState(1);
  const content = useRef(null);
  const container = useRef(null);

  const createContentRef = useCallback((element) => {
    content.current = element;

    if (element) {
      const contentHeight = element.offsetHeight;
      setHeight(contentHeight);
    }
  }, []);

  const createContainerRef = useCallback((element) => {
    container.current = element;
  }, []);

  const animateHeight = useCallback(() => {
    if (!container.current || !content.current) {
      return;
    }

    const contentHeight = content.current.offsetHeight;
    const newContentHeight = loading ? staticHeight : contentHeight;

    setHeight(newContentHeight);
  }, [loading, staticHeight]);

  useEffect(() => {
    animateHeight();
    setOpacity(loading ? 0 : 1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const {
    Container: { component: Container, props: containerProps },
    Content: { component: Content, props: contentProps },
    ErrorScreen: { component: ErrorScreen, props: errorScreenProps } } =
  useOverrides(defaultComponents, overrides);

  return /*#__PURE__*/(
    React.createElement(Container, _extends({
      testId: "shimming-card",
      containerRef: createContainerRef,
      className: className,
      defaultHoverBehavior: defaultHoverBehavior,
      elevated: elevated,
      loading: loading,
      height: height },
    containerProps), /*#__PURE__*/

    React.createElement(Content, _extends({ ref: createContentRef }, contentProps, { opacity: opacity }),
    !hasError && children,

    hasError && /*#__PURE__*/
    React.createElement(ErrorScreen, _extends({
      title: errorTitle,
      message: errorMessage,
      contactButtonText: contactButtonText,
      onContactButtonClick: onContactButtonClick },
    errorScreenProps)), /*#__PURE__*/



    React.createElement(ReactResizeDetector, {
      handleHeight: !loading,
      handleWidth: false,
      onResize: animateHeight })), /*#__PURE__*/



    React.createElement(ShimmerEffect, { active: loading })));


};

ShimmingCard.defaultComponents = defaultComponents;

export default ShimmingCard;